export default {"src":"/_next/static/media/Shield-green.3d1a5825.svg","height":1600,"width":1600};